import showTextareaCharacterCount from "../module/character-count";

import SponsorPlanSelector from 'fortee/js/module/sponsor-plan-selector';

document.addEventListener('DOMContentLoaded', function() {
    SponsorPlanSelector.init();
});

showTextareaCharacterCount();
